import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption3SecondaryProps extends ITextBoxProps {}

export const TextBoxCaption3Secondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Caption3,
  ...rest
}: ITextBoxCaption3SecondaryProps): JSX.Element => (
  <TextBox title={title} color={color} font={font} {...rest} />
)
